import type { DisplayAgelessAssessment } from "@orval/model";

const KNOWN_WELLNESS_INTEREST_IDS = new Set([
  "cognitive",
  "energy",
  "fat-reduction",
  "hormones",
  "longevity",
  "muscle_toning",
  "muscular",
  "sexual-health",
  "sleep",
  "supplements",
  "weight",
  "weight-management",
  "weight_management",
]);

export function filterSupportedWellnessInterests(
  interests: readonly string[] | null | undefined,
): string[] {
  return (interests ?? []).filter((interestId) => KNOWN_WELLNESS_INTEREST_IDS.has(interestId));
}

export function hasExpectedWellnessGeneratedVisuals(
  assessment: Pick<DisplayAgelessAssessment, "wellnessCombinedImageUrl"> | null | undefined,
): boolean {
  return Boolean(assessment?.wellnessCombinedImageUrl);
}
